<template>
    <div>
        <h2>ABOUT</h2>
        <div>
          <img style="width:60%; max-width: 600px;" alt="Vue logo" src="../../assets/animal_crossing.jpg">
        </div>

        <b-container class="text-left mt-4 mb-5">
          <b-row>
            <b-col>
              <p>Hi, my name is Aaron and this page is all about me. 
                If you wish to know all of the exciting education and career 
                history that has shaped me read below. 
                Otherwise, feel free to skip to the fun personal details like pictures 
                of my dogs and what are my favorite games.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h4 class="text-center mt-4 mb-3">Education</h4>
              <p> I went into college with very little planned. I started at Southern Illinois University Carbondale where I tried several different classes ranging from film theory, 3D animation, 
and an intro to programming. Still somewhat undecided in my major, knowing I really enjoyed the modeling class and along with my partner who got into the Disney College Program in Orlando, and transfer to the 
University of Central Florida after a year at SIU. It didn't take long though to find UCF's prestigious animation program was nothing like the 3D modeling class that I had enjoyed as it required a lot of fundamental classes with physical mediums that I quite struggled with. It wasn't until at least halfway through my third year of college I had started to find what I really enjoyed, and that was taking Game Design classes under the Digital Media program and programming classes under the Computer Science program. I managed to combine a lot of the other credits I had taken and end up graduating in 2020 at the beginning of COVID with an Inderdisciplinary Studies degree with a focus in Art and Communication and minors in Digital Media and Computer Science. I graduated Cum Laude, with the only grades that ever dragged me down were the dreaded French classes. 
Part of what helped me grow and solidify my passions in game design and programming was when I went to my first game jam. In 2019, I participated in the Intergalactic Space Jam in Orlando. 
I joined a random team of people and worked under another developer using the Unreal Engine. I had never used Unreal or C++, so it was a long 3 days, but I had pushed through and learned a lot. 
The team I worked with was amazing and I would soon continue to try out more game jams. 
The next game jam I participated in was smaller and I had decided to attempt it all on my own. I wasn't able to ship as polished of a game out in the weekend that the Global Game Jam 2020 took place. 
I was very ambitious, but it was a lot of fun and a great learning experience. 
I hope to continue trying out game jams, though I haven't been able to participate much over the COVID years.  </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h4 class="text-center mt-4 mb-3">Career</h4>
              <p>So far in my long career after leaving college in 2020, 
I have had the opportunity to rise through the ranks at QuaverEd as a software developer. 
Starting out as a Jr. Dev Assistant of sorts, to now being a full Software Developer taking on many of the lead responsibilities and 
working closely with the Team Lead of Integrations Development. The Integrations team at QuaverEd is in charge 
of authentication of logins through Single-Sign-On, Rostering, and a internal/external data website to 
review data such as usage reports and SSO metrics. After 8 months, I was promoted to a full fledged 
Software Developer on our C# Back-End team. With the new responsibilities I was able to continue learning 
and developing new functionality for the Integration products. Before reaching a year, the Team Lead had 
left and a new lead took his place. Following the void left behind by the previous lead I was able to take 
on even more responsibilities working hand in hand with the new Team Lead, learning project management and 
lots of documentation of our processes.</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h4 class="text-center mt-4 mb-3">Personal</h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" md="4">
              Before I get to favorite games and pictures of my two dogs come a note on the love story. 
              I am of the lucky few who found their life partner in high school and actually still enjoyed 
              each other through and after college. We got married in 2018 and are now pushing 5 years 
              married and 9 since dating at the time of writing this. 
            </b-col>
            <b-col cols="6" md="4">
              <img style="width:inherit" src="../../assets/meanddarby.jpg" alt="Me and my spouse Darby"/>
            </b-col>
            <b-col cols="6" md="4">
              <img style="width:inherit" src="../../assets/ladyandruby.jpg" alt="Me and my spouse Darby"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <img style="width:inherit" src="../../assets/lady_atek.jpg" alt="Me and my spouse Darby"/>
              <div class="text-center">
                <span>Lady: small, Ruby: Big</span>
              </div>
            </b-col>
            <b-col>
              Not long after being wed, we adopted our first dog: Lady. 
              Lady had quite the background, hailing from Puerto Rico and having been part of a group of 
              dogs rescued post Hurricane Irma. She was clearly quite traumatized and would barely eat and 
              not let anyone close to her, and on top of all of that had Heartworms. But when she showed an 
              ounce of life when we went to the Pet Alliance of Orlando it was already a done deal. <br>
              Our second dog, Ruby, came a little over a year later. She was given to Pet Alliance for not 
              being enough of a 'guard' dog, but I can assure she is quite the barker still. Her and Lady 
              have been best of friends since:
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              And finally, what I imagine a game/software developer wants to know looking at my about me: 
              what games do I like? As for genres/tags?, some of my favorites fall under the Survival/
              Open-World-Crafters, Base-Building, and Rogue-likes. As my top lists change often, 
              here are some of my favorites currently: Terraria, Subnautica, Animal Crossing New Horizons, 
              Satisfactory, Risk of Rain 2, Pokemon, Chivalry II, and Elden Ring. <br>
              My favorite shows are: Jojo's Bizarre Adventure, Hunter X Hunter, Yuuri on Ice, Beastars, 
              One Punch Man and Mob Psycho 100. 
            </b-col>
          </b-row>
        </b-container>
    </div>
</template>

<script>
export default {
  name: 'AboutPage',
  props: {
    
  }
}
</script>

<style>

</style>